import { httpService } from '@/services/HttpService';

class RegistrationService {
  createAccount(name: string, email: string, password: string): Promise<any> {
    return httpService.post('accounts', {
      name,
      email,
      password,
      password_confirmation: password,
      locale: (window as any).VueGlobal.$i18n.locale || localStorage.getItem('locale'),
    });
  }
  activate(token: string): Promise<any> {
    return httpService.get(`accounts/${token}/activate`);
  }
  getInvitation(token: string): Promise<any> {
    return httpService.get(`accounts/invitations/${token}`, {}, { isErrorSuppressed: true });
  }
  acceptInvitation(token: string): Promise<any> {
    return httpService.post(`invitations/${token}`, {});
  }
  resendActivationEmail(email: string): Promise<any> {
    return httpService.post('accounts/resend_activation', { email });
  }
}

export const registrationService = new RegistrationService();
